import Vue from 'vue'
import ProctorSQDialog from './src/main'

ProctorSQDialog.install = (options) => {
  if (document.querySelector('.proctorSQDialog')) {
    return
  }
  const AlterBox = Vue.extend(ProctorSQDialog)
  let instance = new AlterBox({
    ...options
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
  })
}

export default ProctorSQDialog



// WEBPACK FOOTER //
// ./src/plugin/proctorSQDialog/index.js